export default {
  // 模块名称
  area: {
    // 按钮类
    button: {
      reset: 'Reset',
      query: 'Query',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addarea: 'Add area',
      editarea: 'Edit area',
      delarea: 'Delete area',
      close: 'Close'
    },
    // 文字标签类
    label: {
      center: 'Area center',
      code: 'Code',
      name: 'Name',
      ownerList: 'Person in charge',
      workshopArea: 'Workshop Access Area',
      parentName: 'Parent Name',
      longitude: 'Longitude',
      latitude: 'Latitude',
      remark: 'Remark'
    },
    // 提示类
    placeholder: {
      name: 'Enter name',
      remark: 'Enter remark',
      ownerList: 'Choose person',
      longitude: 'Enter longitude',
      latitude: 'Enter latitude'
    },
    // 消息类
    message: {
      deltips: 'This will permanently delete the selected area. Continue?',
      selecttips: 'Please select a region',
      delSuccess: 'Area deleted successfully',
      addSuccess: 'Area added successfully',
      editSuccess: 'Area edited successfully',
      nodelete: 'There are children under this area {name}, and deletion is not allowed.',
      lng: 'Please enter between -180 and 180, with a maximum of 10 decimal places',
      nospace: 'No spaces are allowed before and after the name',
      name: 'Enter area name',
      ownerList: 'Choose person',
      less30: '1 to 30 characters in length',
      less15: '1 to 15 characters in length',
      lat: 'Please enter between -90 and 90, with a maximum of 10 decimal places',
      less200: '0 to 200 characters in length'
    },
    // 标题类
    title: {
      warn: 'Warning',
      add: 'Add area',
      edit: 'Edit area',
      view: 'View area'
    }
  }
}
